module.exports = __webpack_public_path__ + "static/logo.70a4da4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = 756
// module chunks = 263791100135453